export default {"src":"/_next/static/media/ico_project.c9b72664.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};